import React, { createContext, useContext, useState } from "react";
import userapi from "../../services/userapi";

// Create the context
const UserContext = createContext();

// Custom hook for using the context
export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
};

// Provider component
export const UserProvider = ({ children }) => {
  // State for user management
  const [users, setUsers] = useState([]);
  const [deliveryPersons, setDeliveryPersons] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [usersError, setUsersError] = useState(null);

  // Add fetchUsers method
  const fetchUsers = async () => {
    try {
      setUsersLoading(true);
      setUsersError(null);
      const allUsers = await userapi.getAllUsers();
      
      // Set all users
      setUsers(allUsers);
      
      // Filter and set delivery persons
      const filteredDeliveryPersons = allUsers.filter(
        (user) =>
          user.roles &&
          user.roles.length === 1 &&
          user.roles[0].name === "ROLE_USER" &&
          user.enabled
      );
      setDeliveryPersons(filteredDeliveryPersons);
      
      return allUsers;
    } catch (error) {
      console.error("Error fetching users:", error);
      setUsersError("Kullanıcı listesi alınırken bir hata oluştu. Lütfen tekrar giriş yapın.");
      throw error;
    } finally {
      setUsersLoading(false);
    }
  };

  const value = {
    // Data
    users,
    deliveryPersons,
    usersLoading,
    usersError,

    // Actions
    fetchUsers,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}; 